import { AlertBanner } from '@/contasis/components/AlertBanner';
import { useAuth } from '@/contexts/ContextoAuth';

export const SuperAdminBanner = () => {
  const { user } = useAuth();

  if (!user?.esSuperAdminSenciyo) return null;

  return (
    <AlertBanner variant="success">
      <strong style={{ fontWeight: 600 }}>Estás dentro de Senciyo como Super Administrador.</strong>
      <span style={{ fontWeight: 500 }}> Tienes acceso a información de todas las empresas de la plataforma.</span>
    </AlertBanner>
  );
};
